"use client";

import { EdgeFade } from "@/components/edge-fade";
import { Button } from "@/components/ui/button";
import { Marquee } from "@/components/ui/marquee";
import { BLUR_DATA_URL } from "@/config/site";
import { FlightSerializers } from "@/feature/flight/search/lib/search";
import { ArrowRight, MapPin, Plane } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { MouseEvent, useState, useTransition } from "react";

const popular_destinations = [
  {
    id: 1,
    agency_id: 8,
    thumbnail: "https://photos.nomadicnotes.com/img/s/v-3/p2759081374-4.jpg",
    order_number: 1,
    from_airport: 210,
    to_airport: 2061,
    status: true,
    from_airport_country: "AUSTRIA",
    from_airport_city: "Vienna",
    from_airport_name: "Vienna International Airport",
    from_airport_code: "VIE",
    to_airport_name: "Salzburg Airport W. A. Mozart",
    to_airport_code: "SZG",
    to_airport_country: "AUSTRIA",
    to_airport_city: "Salzburg",
  },
  {
    id: 14,
    agency_id: 8,
    thumbnail:
      "https://www.opulentroutes.com/wp-content/uploads/2021/04/Dhaka.jpg",
    order_number: 2,
    from_airport: 212,
    to_airport: 210,
    status: true,
    from_airport_country: "AUSTRIA",
    from_airport_city: "Salzburg",
    from_airport_name: "Salzburg Airport W. A. Mozart",
    from_airport_code: "SZG",
    to_airport_name: "Vienna International Airport",
    to_airport_code: "VIE",
    to_airport_country: "AUSTRIA",
    to_airport_city: "Vienna",
  },
  {
    id: 19,
    agency_id: 8,
    thumbnail: "https://photos.nomadicnotes.com/img/s/v-3/p2759081374-4.jpg",
    order_number: 3,
    from_airport: 212,
    to_airport: 2061,
    status: true,
    from_airport_country: "AUSTRIA",
    from_airport_city: "Vienna",
    from_airport_name: "Vienna International Airport",
    from_airport_code: "VIE",
    to_airport_name: "Innsbruck Airport",
    to_airport_code: "INN",
    to_airport_country: "AUSTRIA",
    to_airport_city: "Innsbruck",
  },
  {
    id: 23,
    agency_id: 8,
    thumbnail:
      "https://images.unsplash.com/photo-1516550893923-42d28e5677af?auto=format&fit=crop&w=1200&q=80",
    order_number: 4,
    from_airport: 891,
    to_airport: 2062,
    status: true,
    from_airport_country: "AUSTRIA",
    from_airport_city: "Vienna",
    from_airport_name: "Vienna International Airport",
    from_airport_code: "VIE",
    to_airport_name: "Salzburg Airport W. A. Mozart",
    to_airport_code: "SZG",
    to_airport_country: "AUSTRIA",
    to_airport_city: "Salzburg",
  },
  {
    id: 24,
    agency_id: 8,
    thumbnail:
      "https://media.istockphoto.com/id/2156283145/photo/the-port-of-chittagong-is-the-busiest-seaport-on-the-coastline-of-the-bay-of-bengal.jpg?s=612x612&w=0&k=20&c=YoG7pPcS-np4otikdGuEMRmOV5XI7HZ48EXKm9DvThA=",
    order_number: 5,
    from_airport: 2061,
    to_airport: 209,
    status: true,
    from_airport_country: "AUSTRIA",
    from_airport_city: "Innsbruck",
    from_airport_name: "Innsbruck Airport",
    from_airport_code: "INN",
    to_airport_name: "Vienna International Airport",
    to_airport_code: "VIE",
    to_airport_country: "AUSTRIA",
    to_airport_city: "Vienna",
  },
  {
    id: 25,
    agency_id: 8,
    thumbnail:
      "https://www.opulentroutes.com/wp-content/uploads/2021/04/Dhaka.jpg",
    order_number: 6,
    from_airport: 2061,
    to_airport: 210,
    status: true,
    from_airport_country: "AUSTRIA",
    from_airport_city: "Vienna",
    from_airport_name: "Vienna International Airport",
    from_airport_code: "VIE",
    to_airport_name: "Linz Airport",
    to_airport_code: "LNZ",
    to_airport_country: "AUSTRIA",
    to_airport_city: "Linz",
  },
  {
    id: 26,
    agency_id: 8,
    thumbnail:
      "https://media.istockphoto.com/id/2156283145/photo/the-port-of-chittagong-is-the-busiest-seaport-on-the-coastline-of-the-bay-of-bengal.jpg?s=612x612&w=0&k=20&c=YoG7pPcS-np4otikdGuEMRmOV5XI7HZ48EXKm9DvThA=",
    order_number: 7,
    from_airport: 2062,
    to_airport: 209,
    status: true,
    from_airport_country: "AUSTRIA",
    from_airport_city: "Linz",
    from_airport_name: "Linz Airport",
    from_airport_code: "LNZ",
    to_airport_name: "Vienna International Airport",
    to_airport_code: "VIE",
    to_airport_country: "AUSTRIA",
    to_airport_city: "Vienna",
  },
  {
    id: 27,
    agency_id: 8,
    thumbnail:
      "https://ecdn.dhakatribune.net/contents/cache/images/640x0x1/uploads/media/2023/09/13/Rajshahi-Development-5-f6819dd6ea94084fd01a011dac7ca45d.jpg",
    order_number: 12,
    from_airport: 2062,
    to_airport: 2058,
    status: true,
    from_airport_country: "AUSTRIA",
    from_airport_city: "Vienna",
    from_airport_name: "Vienna International Airport",
    from_airport_code: "VIE",
    to_airport_name: "Klagenfurt Airport",
    to_airport_code: "KLU",
    to_airport_country: "AUSTRIA",
    to_airport_city: "Klagenfurt",
  },
  {
    id: 28,
    agency_id: 8,
    thumbnail:
      "https://www.thelandofsnows.com/wp-content/uploads/2018/12/Kathesimbhu-stupa-Nepal-1024x683.jpg",
    order_number: 9,
    from_airport: 1352,
    to_airport: 996,
    status: true,
    from_airport_country: "AUSTRIA",
    from_airport_city: "Vienna",
    from_airport_name: "Vienna International Airport",
    from_airport_code: "VIE",
    to_airport_name: "Zurich Airport",
    to_airport_code: "ZRH",
    to_airport_country: "SWITZERLAND",
    to_airport_city: "Zurich",
  },
  {
    id: 29,
    agency_id: 8,
    thumbnail:
      "https://www.thelandofsnows.com/wp-content/uploads/2018/12/Kathesimbhu-stupa-Nepal-1024x683.jpg",
    order_number: 10,
    from_airport: 210,
    to_airport: 996,
    status: true,
    from_airport_country: "AUSTRIA",
    from_airport_city: "Vienna",
    from_airport_name: "Vienna International Airport",
    from_airport_code: "VIE",
    to_airport_name: "Munich Airport",
    to_airport_code: "MUC",
    to_airport_country: "GERMANY",
    to_airport_city: "Munich",
  },
  {
    id: 30,
    agency_id: 8,
    thumbnail:
      "https://media.istockphoto.com/id/2156283145/photo/the-port-of-chittagong-is-the-busiest-seaport-on-the-coastline-of-the-bay-of-bengal.jpg?s=612x612&w=0&k=20&c=YoG7pPcS-np4otikdGuEMRmOV5XI7HZ48EXKm9DvThA=",
    order_number: 11,
    from_airport: 2061,
    to_airport: 209,
    status: true,
    from_airport_country: "AUSTRIA",
    from_airport_city: "Vienna",
    from_airport_name: "Vienna International Airport",
    from_airport_code: "VIE",
    to_airport_name: "Milan Malpensa Airport",
    to_airport_code: "MXP",
    to_airport_country: "ITALY",
    to_airport_city: "Milan",
  },
  {
    id: 31,
    agency_id: 8,
    thumbnail:
      "https://ecdn.dhakatribune.net/contents/cache/images/640x0x1/uploads/media/2023/09/13/Rajshahi-Development-5-f6819dd6ea94084fd01a011dac7ca45d.jpg",
    order_number: 12,
    from_airport: 2062,
    to_airport: 2058,
    status: true,
    from_airport_country: "AUSTRIA",
    from_airport_city: "Graz",
    from_airport_name: "Graz Airport",
    from_airport_code: "GRZ",
    to_airport_name: "Vienna International Airport",
    to_airport_code: "VIE",
    to_airport_country: "AUSTRIA",
    to_airport_city: "Vienna",
  },
];

function getDefaultDepartureDate() {
  const now = new Date();
  const departure = new Date(now);

  if (now.getHours() >= 18) {
    departure.setDate(departure.getDate() + 1);
  }

  const year = departure.getFullYear();
  const month = String(departure.getMonth() + 1).padStart(2, "0");
  const day = String(departure.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export const PopularDestination = () => {
  const router = useRouter();
  const [activeCardId, setActiveCardId] = useState<number | null>(null);
  const [isPending, startTransition] = useTransition();

  const getFlightHref = (
    destination: (typeof popular_destinations)[number],
  ) => {
    const departDate = getDefaultDepartureDate();
    const route = FlightSerializers.flights([
      {
        from: {
          iata_code: destination.from_airport_code,
          name: destination.from_airport_name,
          city_name: destination.from_airport_city,
          country: destination.from_airport_country,
        },
        to: {
          iata_code: destination.to_airport_code,
          name: destination.to_airport_name,
          city_name: destination.to_airport_city,
          country: destination.to_airport_country,
        },
        departDate,
      },
    ]);

    const searchParams = new URLSearchParams({ trip: "oneway", route });
    return `/flights?${searchParams.toString()}`;
  };

  const handleCardNavigation = (
    event: MouseEvent<HTMLAnchorElement>,
    destination: (typeof popular_destinations)[number],
    href: string,
  ) => {
    event.preventDefault();

    if (isPending) {
      return;
    }

    setActiveCardId(destination.id);
    startTransition(() => {
      router.push(href);
    });
  };

  return (
    <>
      <div className="flex flex-col items-start gap-2 mb-8 ">
        <span className="text-xs font-bold tracking-[0.15em] text-primary uppercase">
          Unforgettable Journeys
        </span>
        <h2 className="text-3xl md:text-4xl font-extrabold tracking-tight text-foreground">
          Popular Destinations
        </h2>
        <p className="max-w-2xl text-muted-foreground md:text-lg">
          Explore our most sought-after destinations, curated for unforgettable
          experiences.
        </p>
      </div>
      <div className="relative overflow-visible pb-10">
        <EdgeFade xSizeClass="w-20 md:w-28" />

        <Marquee pauseOnHover className="[--gap:1rem]  pb-10">
          {popular_destinations.map((destination) => {
            const href = getFlightHref(destination);
            const isCardLoading = isPending && activeCardId === destination.id;

            return (
              <Link
                key={destination.id}
                href={href}
                onClick={(event) =>
                  handleCardNavigation(event, destination, href)
                }
                aria-disabled={isPending}
                tabIndex={isPending ? -1 : undefined}
                className={`group relative h-72 w-56 shrink-0 overflow-hidden rounded-3xl border border-border/50 bg-slate-950 shadow-xl transition-all duration-500 ease-out md:h-80 md:w-64 ${
                  isPending
                    ? "cursor-not-allowed opacity-70"
                    : "cursor-pointer hover:-translate-y-2 hover:shadow-[0_20px_40px_-15px_rgba(0,0,0,0.5)] hover:border-border"
                }`}
              >
                {/* Background Image */}
                <div className="absolute inset-0 z-0">
                  {destination.thumbnail && (
                    <Image
                      src={destination.thumbnail}
                      alt={`Flights from ${destination.from_airport_city} to ${destination.to_airport_city}`}
                      fill
                      className="object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                      sizes="(max-width: 768px) 240px, 300px"
                      quality={85}
                      placeholder="blur"
                      blurDataURL={BLUR_DATA_URL}
                      loading="lazy"
                    />
                  )}
                  {/* Cinematic gradients for depth and text legibility */}
                  <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/90 transition-opacity duration-500" />
                  <div className="absolute inset-0 bg-black/0 transition-colors duration-500 group-hover:bg-black/20" />
                </div>

                {/* Loading State Overlay */}
                {isCardLoading && (
                  <div className="absolute inset-0 z-20 flex flex-col items-center justify-center bg-black/40 backdrop-blur-[2px]">
                    <div className="h-8 w-8 animate-spin rounded-full border-4 border-white/20 border-t-white" />
                    <span className="mt-3 text-sm font-medium text-white drop-shadow-md">
                      Loading fares...
                    </span>
                  </div>
                )}

                {/* Content Overlay */}
                <div className="relative z-10 flex h-full flex-col justify-between p-6">
                  {/* Origin Badge */}
                  <div className="self-start">
                    <div className="inline-flex items-center gap-1.5 rounded-full bg-black/40 backdrop-blur-md border border-white/20 px-3 py-1.5 shadow-sm transition-all duration-300 group-hover:bg-black/60">
                      <Plane className="w-3.5 h-3.5 text-white/90 shrink-0" />
                      <span className="text-xs font-semibold text-white/90 tracking-wide">
                        From {destination.from_airport_city}
                      </span>
                    </div>
                  </div>

                  {/* Destination Info */}
                  <div className="flex flex-col justify-end translate-y-12 transition-transform duration-500 ease-out group-hover:translate-y-0">
                    <div className="mb-2 flex items-center gap-2">
                      <div className="flex h-6 w-6 items-center justify-center rounded-full bg-white/20 backdrop-blur-sm shadow-sm ring-1 ring-white/30">
                        <MapPin className="h-3 w-3 text-white" />
                      </div>
                      <span className="text-xs font-bold tracking-[0.15em] text-white/80 uppercase">
                        {destination.to_airport_country}
                      </span>
                    </div>

                    <h3 className="mb-5 text-3xl font-extrabold tracking-tight text-white drop-shadow-lg md:text-4xl text-balance">
                      {destination.to_airport_city}
                    </h3>

                    {/* Action Button */}
                    <div className="opacity-0 transition-opacity duration-500 delay-75 group-hover:opacity-100">
                      <Button
                        variant="secondary"
                        className="w-full gap-2 rounded-xl border border-transparent bg-white/90 text-black hover:bg-white backdrop-blur-sm pointer-events-none transition-all shadow-[0_0_20px_-5px_rgba(255,255,255,0.3)]"
                        size="lg"
                      >
                        Explore Fares
                        <ArrowRight className="w-4 h-4" />
                      </Button>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </Marquee>
      </div>
    </>
  );
};
